import { Link } from 'react-router-dom'
const ExaminationPromotion = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Examination & Promotion</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Rules</li>
                    <li>|</li>
                    <li>Examination & Promotion</li>
                </ul>
            </div>
            <div className="inner_page uniform_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className="heading">The School year has three terms:</h3>
                            <div className="tab-view">
                                <button>Mar to May</button>
                                <button>Jul to Oct</button>
                                <button>Nov to Feb</button>
                            </div>
                            <ul className="list-view">
                                <li>Examination will be held at the end of each term and no student will be allowed to take the examinations earlier or later. Those absent form an examination with out a grave cause will be considered as having failed in the particular subject; in case of illness a doctor's certificate should be produced.</li>
                                <li>Those who absent themselves in any subject shall be considered failed in that subject and shall not be awarded any position, an and shall not be re-examined. In case of grave illness, a medical certificate to the effect shall be produced.</li>
                                <li>Regular periodical tests will be conducted in addition to the term examinations. Marks obtained in all the tests and term examinations will be taken into consideration for promotion.</li>
                                <li>A pupil shall be eligible to appear in the Final Examination only if he/she has 85% of the total attendance.</li>
                                <li>Anyone found indulging in any malpractice during an examination is liable to be debarred from further examinations.</li>
                                <li>Criteria for promotion after final Examination shall be 45% of the aggregate marks obtained by the candidate in all the papers and examinations besides the internal assessment made by the school. The principal is at liberty to follow strictly the ICSE promotion scheme for the students.</li>
                                <li>Result declared at the end of the year will be final and will not be reconsidered, nor will the answer paper be shown.</li>
                                <li>A student who fails in two consecutive final examinations will have to leave the school.</li>
                                <li>Those who seek admission in this school will have to accept this scheme of promotion. The decision of the decision of the school in the matter of promotion is final and irrevocable.</li>
                                <li>While reviewing each report guardians are requested to examine the home work diary of the student. Its will be helpful in understanding as to why he/she has not come up to the expectation.</li>
                                <li>Promotion to a higher class depends upon:
                                    <ol>
                                        <li>Regularity in attendance.</li>
                                        <li>Regularity and quality of day-to-day participation in the class.</li>
                                        <li>Assessment by the teachers of different subjects.</li>
                                        <li>Written works and projects assigned by the subjects teachers.</li>
                                        <li>Average marks of the term examinations.</li>
                                    </ol>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExaminationPromotion
